import SectionHeaderWithIcon from "@/components/company/shared/section-header-with-icon";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";

const CATEGORIES_LIMIT = 4;

type CompanyMarketSectionProps = {
  readonly company: CompanyDTO;
  readonly className?: string;
};

export default function CompanyMarketSection({
  company,
  className,
}: CompanyMarketSectionProps) {
  const { t } = useTranslation();
  const visibleCategories = (company.categories ?? []).slice(
    0,
    CATEGORIES_LIMIT,
  );
  const hasMarketSection =
    company.isB2B != null || visibleCategories.length > 0;

  if (!hasMarketSection) return null;

  return (
    <section className={className}>
      <SectionHeaderWithIcon title={t("company.insights.market.title")} />
      <div className="flex flex-wrap gap-1.5">
        {company.isB2B === true && (
          <Badge variant="default">{t("company.insights.market.b2b")}</Badge>
        )}
        {company.isB2B === false && (
          <Badge variant="default">{t("company.insights.market.b2c")}</Badge>
        )}
        {visibleCategories.map((category) => (
          <Badge key={category} variant="secondary">
            {category}
          </Badge>
        ))}
      </div>
    </section>
  );
}
